import "./AddTeam.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddTeamComponentController from "./AddTeamComponentController";

export default class AddTeamComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddTeamComponentController;
        this.templateUrl = "/App/Components/Teams/AddTeam/AddTeam.html";
    }
}

module("mmManagePortal").component("mmAddTeam", new AddTeamComponent());
